/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import { NgModule } from '@angular/core';
import {
  MkadSmartTableColumnComponent
} from './components/mkad-smart-table-column/mkad-smart-table-column.component';
import {TableButtonComponent} from './components/atoms/table-button/table-button.component';
import {NgClass} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NbTooltipModule} from '@nebular/theme';



@NgModule({
  declarations: [],
  imports: [
    MkadSmartTableColumnComponent,
    TableButtonComponent,
    NgClass,
    TranslateModule,
    NgxDatatableModule,
    NbTooltipModule,
  ],
  exports: [
    MkadSmartTableColumnComponent,
    TableButtonComponent,
    NgClass,
    TranslateModule,
    NgxDatatableModule,
    NbTooltipModule,
  ]
})
export class MkadTableModule { }
